/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export enum MessageType {
  spgiFusionSystem = "spgiFusionSystem",
  webpackOk = "webpackOk",
}
